var {AmpersandView} = require('catalog/libs');

/**
 * html loader tab view
 */
var HTMLLoaderTabView = AmpersandView.extend({

    template: '<div></div>',

    bindings: {
        'model.content': {
            type: 'innerHTML',
            selector: 'div'
        }
    }
});

module.exports = HTMLLoaderTabView;
